import { BCMSRecord, useGlobalController, useRoute } from "@bcm-dev/bcms-vite";
import { Biller } from "model";

import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from "compid/custom-ui/CustomModal";
import "./styles.css";

/**
 * @function ConfirmTurnOffEBillModal
 * @returns {React.Component}
 * @exported true
 * @description The confirmation modal for the turn off eBill workflow
 * @example
 * <ModalOpen id="ConfirmTurnOffEBillModal">Turn off eBill</ModalOpen>
 */
export default function ConfirmTurnOffEBillModal(props) {
  const biller = props.data ?? Biller.firstInstanceOf();

  const controller = useGlobalController();
  const navigate = useRoute();
  
  // Set the biller ebill status to Not Enrolled and update global state
  // then route back to the previous page
  const confirm = evt => {
    biller.eBillStatus = "Not Enrolled";
    BCMSRecord.batch([ Biller.update(biller) ], controller);

    navigate(-1);
  }

  return (
    <CustomModal id="ConfirmTurnOffEBillModal" title="" className="confirm-turn-off-ebill-modal">
      <CustomModalContent className="flex-container flex-vertical">
        <h3><b>Are you sure you want to turn off eBills?</b></h3>
        <p className="sub-text">Sorry to see you go, but you can turn the service on again at any time.</p>
        <p className="sub-text">Remember, your scheduled payments will still be processed unless you cancel them manually.</p>
      </CustomModalContent>

      <CustomModalFooter className="form-button-container button-container flex-container flex-horizontal">
        <ModalCloseButton text="Don't cancel eBill" id="ConfirmTurnOffEBillModal" />
        <ModalPrimaryButton text="Cancel eBill" onClick={ confirm } />
      </CustomModalFooter>
    </CustomModal>
  );
}